import { createContext, useContext } from 'react';
import type { Me, Workspace } from '../api/client';

export interface SessionValue {
  me: Me;
  reload: () => void;
}

export const SessionContext = createContext<SessionValue | null>(null);

/** The signed-in user (only inside the signed-in part of the app). */
export function useSession(): SessionValue {
  const v = useContext(SessionContext);
  if (!v) throw new Error('useSession outside a signed-in page');
  return v;
}

export function findWorkspace(me: Me, id: number): Workspace | undefined {
  return me.workspaces.find((w) => w.id === id);
}

const LAST = 'shipyard.workspace';

/** The workspace the browser last showed (a convenience; storage may be unavailable). */
export function lastWorkspace(): number | null {
  try {
    const v = Number(window.localStorage.getItem(LAST));
    return Number.isInteger(v) && v > 0 ? v : null;
  } catch {
    return null;
  }
}

export function rememberWorkspace(id: number): void {
  try {
    window.localStorage.setItem(LAST, String(id));
  } catch {
    // storage blocked
  }
}
